import { checkIban } from '../../api/checkIban';
import createAsyncValidator from '../../core/createAsyncValidator';

const ibanValidation = () => createAsyncValidator(checkIban);

export default ibanValidation;
